import Common from "../layout/Common.vue"
import basicRouters from "./basicRouter"
export default {
	path: "/",
	name: "Home",
	component: Common,
	children: [{
			path: "userManage",
			name: "userManageIndex",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/userManage/index.vue")
		},
		{
			path: "userManage/detailCount",
			name: "userManageDetailCount",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/userManage/detailCount.vue")
		},
		{
			path: "userManage/addCount",
			name: "userManageAddCount",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/userManage/addCount.vue")
		},
		{
			path: "userManage/importAccount",
			name: "userManageImportAccount",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/userManage/importAccount.vue")
		},
		{
			path: "department",
			name: "departmentIndex",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/department/index.vue")
		},
		{
			path: "userContact",
			name: "userContactIndex",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/userContact/index.vue")
		},
		{
			path: "userContact/addUserContact",
			name: "userContactAddUserContact",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/userContact/addUserContact.vue")
		},
		{
			path: "userContact/detailUserContact",
			name: "userContactDetail",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/userContact/detailUserContact.vue")
		},
		{
			path: "department/detail",
			name: "departmentDetail",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/department/detail.vue")
		},
		{
			path: "clientManage",
			name: "clientManageIndex",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/clientManage/index.vue")
		},
		{
			path: "clientManage/addClient",
			name: "clientManageAddClient",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/clientManage/addClient.vue")
		},
		{
			path: "clientManage/detailClient",
			name: "clientManageDetailClient",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/clientManage/detailClient.vue")
		},
		{
			path: "aiService",
			name: "aiService",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/aiService/index.vue")
		},
		{
			path: "settings",
			name: "settings",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/systemSetting/index.vue")
		},
		{
			path: "editPassword",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/editPassword/index.vue")
		},
		{
			path: "groupManage",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/groupManage/index.vue")
		},
		{
			path: "groupManage/detailGroup",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/groupManage/detailGroup.vue")
		},
		{
			path: "auditLog",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/auditLog/index.vue")
		},
		{
			path: "certificationSource",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/certificationSource/index.vue")
		},
		{
			path: "certificationSource/addSource",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/certificationSource/addSource.vue")
		},
		{
			path: "certificationSource/detail",
			meta: {
				requiresAuth: true
			},
			component: () => import("@/views/certificationSource/detail.vue")
		},
		// {
		// 	path: 'Individual',
		// 	meta: {
		// 		requiresAuth: true
		// 	},
		// 	component: () => import('@/views/Individual/index.vue')
		// },
    {
			path: 'securitySetting',
			meta: {
				requiresAuth: true
			},
			component: () => import('@/views/securitySetting/index.vue')
		},
		...basicRouters
	]
}
